import { MouseEventHandler } from "react";

import { useDom } from "../../../../../../../../context/Dom";
import { LocationShape } from "../../../../../../../../types";
import MenuItemContents from "../components/MenuItemContents/MenuItemContents";
import { MenuItemChildren } from "../types";
import useMenuItemStyles from "../utils/useMenuItemStyles";

type MenuLinkProps = {
  children: MenuItemChildren;
  to: string | LocationShape;
  onClick?: MouseEventHandler;
  ariaLabel?: string;
  state?: any;
};

export default function ContextMenuLink({
  children,
  to,
  onClick,
  ariaLabel,
  state
}: MenuLinkProps) {
  const { Link } = useDom();
  const styles = useMenuItemStyles();

  const derivedState = state ?? (typeof to === "string" ? undefined : to.state);

  return (
    <Link
      {...styles}
      className="focus-malibu"
      aria-label={ariaLabel}
      onClick={onClick}
      to={to}
      state={derivedState}
    >
      <MenuItemContents>{children}</MenuItemContents>
    </Link>
  );
}
